// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xoqm","title":"Header_title__1Q4sX","side":"Header_side__FxzSd"};